export const weekDayDateFormat = "LmznS";
export default {weekDayDateFormat};